import {Injectable, inject} from '@angular/core'
import {Outlet} from '@models/outlet'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {OutletService} from '@service/outlet/outlet.service'

/**
 * Variante embebida de `OutletService`.
 *
 * @description
 * En modo embebido no existe "listado de outlets" (la pantalla contenedora siempre fija
 * un único outlet). Por eso `getAllOutlets` devuelve array vacío, `getOutlet` devuelve
 * el signal enviado por el host y las relaciones outlet↔distribuidor se toman del
 * payload sin golpear PouchDB.
 */
@Injectable({
  providedIn: 'root',
})
export class OutletEmbeddedService extends OutletService {
  private readonly orderEmbbdedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)
  override getAllOutlets = async (): Promise<Outlet[]> => []
  override getOutlet = async (id: string, useSingleton = true): Promise<Outlet> =>
    this.orderEmbbdedStoreService.outlet()

  override preGetOutletRelationCodes = async (): Promise<void> => {
    this.outletRelationCodes = this.orderEmbbdedStoreService.outletRelationCodes()
  }
}
